<template>
  <div>
    REFERRAL
    {{filterType}}
    <div class="column">
      <div class="custom_table_filters column">
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterStartDate"
            name="uniquename"
            :placeholder="$t('msg.start_date')"
          ></datepicker>
        </div>
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterEndDate"
            name="uniquename"
            :placeholder="$t('msg.end_date')"
          ></datepicker>
        </div>

        <div class="component_normal_input_block dis_inb main_white_bg">
          <select v-model="filterType">
            <option value="all">{{$tc("msg.all",1)}}</option>
            <option value="cancelled">{{$tc("msg.cancelled",1)}}</option>
            <option value="done">{{$tc("msg.done",1)}}</option>
            <option value="waiting">{{$tc("msg.waiting",1)}}</option>
          </select>
        </div>
        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="applyFilter()"
        >{{$tc("msg.apply_filter",1)}}</button>
        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="clearFilter()"
        >{{$tc("msg.clear_filter",1)}}</button>
      </div>
    </div>
    <div class="column">
      search
      <input v-model="searchBox">
    </div>
    <div class="column ">
      <vue-good-table
        :columns="columns"
        :rows="purchasesOnPage"
        :select-options="{ enabled: false}"
        :search-options="{ enabled: true,
            searchFn: customSearch,
            externalQuery: searchBox, }"
        ref="historytable"
        :line-numbers="true"
        :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'createdAt', type: 'desc'}
                     }"
        :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      perPage: '5',
                      position: 'down',
                      perPageDropdown: [10, 15, 20],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
      >
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label =='id'">{{$t("msg.id")}}</span>
          <span v-if="props.column.label =='sourceAmount'">{{$t("msg.sourceAmount")}}</span>
          <span v-if="props.column.label =='createdAt'">{{$t("msg.createdAt")}}</span>
        </template>

        <template slot="table-row" slot-scope="props">
          <!-- <span v-if="props.column.field == 'tokenTxid'">
            <a :href="'http://explorer.nemchina.com/#/s_tx?hash='+props.formattedRow[props.column.field]" target="blank_">{{ajustTokenID(props.formattedRow[props.column.field])}}</a>
          </span> -->
          <span v-if="props.column.field == 'createdAt'">
            {{props.formattedRow[props.column.field]}}
          </span>
          <!-- <span v-if="props.column.field == 'updatedAt'">
            {{props.formattedRow[props.column.field]}}
          </span>
          <span v-if="props.column.field == 'sourceAmount'">
            <span
              v-if="props.formattedRow[props.column.field] > 0"
            >{{ props.formattedRow[props.column.field]}} {{props.row.sourceCurrency.symbol}}</span>
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'status'">
            {{props.formattedRow[props.column.field]}}
          </span> -->
          <span v-if="props.column.field == 'actions'">
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>

        <div slot="emptystate">
          <p class="tac">{{$tc("msg.no_data_found",1)}}</p>
        </div>
      </vue-good-table>
      <!-- {{deposits}} -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
// import moment from 'moment'

export default {
  created() {
    this.getRewards();
  },
  mounted() {},
  data: () => ({
    rewards,

    
    searchBox: "",
    filterType: "all",
    filterStartDate: "",
    filterEndDate: "",
    purchases: [],
    purchasesOnPage: [],
    columns: [
      {
        label: "id",
        field: "tokenTxid",
        filterable: true
      },
      {
        label: "createdAt",
        field: "createdAt",
        filterable: true
      },
      {
        label: "updatedAt",
        field: "updatedAt",
        filterable: true
      },
      {
        label: "sourceAmount",
        field: "sourceAmount",
        type: "number",
        filterable: true
      },
      {
        label: "status",
        field: "status",
        filterable: true
      },
      {
        label: "actions",
        field: "actions",
        filterable: false
      }
    ]
  }),
  components: {
    Datepicker
  },
  methods: {
    async getRewards() {
      try {
        let resp = await this.$store.dispatch("getRewards");
        this.rewards = resp.data;
        this.purchasesOnPage = this.rewards;
      } catch (e) {
        console.log(e);
      }
    },

    sortByCreatedAt(array) {
      array.sort((a, b) => {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });
      return array;
    },

    convertDates() {
      let purchasesFix = this.purchases;
      let self = this;
      purchasesFix.forEach(function(purchase, index) {
        purchase.createdAt = self.filterDate(purchase.createdAt);
        purchase.updatedAt = self.filterDate(purchase.updatedAt);
      });
    },
    filterDate(dateToFilter) {
      let date = new Date(dateToFilter);
      let day = date.getDate();
      let year = date.getFullYear();
      let month = date.getUTCMonth() + 1;
      let hour = date.getUTCHours();
      let minute = date.getUTCMinutes();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      return year + "/" + month + "/" + day + " - " + hour + ":" + minute;
    },

    applyFilter() {
      if (this.filterType !== "all") {
        this.purchasesOnPage = this.purchases;
        let newPurchasesOnPage = this.purchasesOnPage.filter(item => {
          return item.status == this.filterType;
        });

        this.purchasesOnPage = newPurchasesOnPage;
        console.log(this.purchasesOnPage);
      } else {
        this.purchasesOnPage = this.purchases;
        console.log(this.purchasesOnPage);
      }

      let startDateOnInput = this.filterStartDate;
      let endDateOnInput = this.filterEndDate;

      this.filterRowByDate(endDateOnInput, startDateOnInput);
    },
    filterRowByDate(endDateOnInput, startDateOnInput) {
      console.log(this.purchasesOnPage);
      this.purchasesOnPage = this.purchasesOnPage.filter(item => {
        return (
          new Date(item.createdAt) <= endDateOnInput &&
          new Date(item.createdAt) >= startDateOnInput
        );
      });
      // this.loadingTransactions = false;
    },
    clearFilter() {
      let vm = this;
      this.purchasesOnPage = this.transactions;
      // this.filterType = "all";
      // this.filterStartDate = new Date(vm.purchasesOnPage[0].createdAt);
      // this.filterEndDate = new Date();
    },

    customSearch(row, col, cellValue, searchTerm) {
      let vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },

    // ajustTokenID(tokenID){

    //   let str = tokenID;
    //   let res = str.substring(0,15);
      
    //   return res+'...';
    // }
  },
  computed: {
    ...mapGetters(["btcValue", "bluValue", "bluAccount"])
  },
  watch: {
    purchases: function() {
      this.convertDates();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/private/transactions/TransactionTableReferral.vue